import React from 'react';
import { classIf, iconSportCssClass } from '../data/utils';
import { useFilter } from '../prematch/by-date/FilterProvider';

export default function SportSelector(props) {
    const filter = useFilter();

    return (
        <div className="c_36">
            <div className="c_36_1">
                {props.sports.map(s => {
                    const icoSport = iconSportCssClass(s.id, s.iconClass);
                    const eventsCount = s.eventsCountByFilter?.[filter] ?? s.eventsCount
                    return (
                        <div key={s.id} className={"c_36_1_1" + classIf(s.id === props.selected, 'active')} onClick={() => props.select(s)}>
                            <div className={"c_36_1_1_1 " + icoSport}></div>
                            <div className="c_36_1_1_2">{s.descrizione}</div>
                            <div className="c_36_1_1_3">{eventsCount}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
